<template>
  <div>
    <p>Ces questions servent de sécurité lors d'actions avec un gros potentiel d'attaque, comme un changement d'identifiant. Veuillez à bien mémoriser ces informations, elles vous seront utiles plus tard.</p>

    <div class="form-group">
      <select
        :class="`form-control${question1 === 0 ? ' form-control-empty' : ''}`"
        data-ob1-component="FormControlEmpty"
        id="question1"
        :value="question1"
        @change="$emit('update:question1', parseInt($event.target.value))"
        aria-labelledby="label-q1"
        required
      >
        <option :value="0"></option>
        <option v-for="q in questions1" :key="q.id" :value="q.id">{{ q.label }}</option>
      </select>
      <label id="label-q1" class="form-control-placeholder" for="question1">Question 1</label>
    </div>
    <div class="form-group">
      <input type="text" id="response1" data-ob1-component="FormControlEmpty"
        :class="`form-control${response1.length === 0 ? ' form-control-empty' : ''}`"
        :value="response1" @input="$emit('update:response1', $event.target.value)"
        aria-labelledby="label-r1" required :disabled="question1 === 0" />
      <label id="label-r1" class="form-control-placeholder" for="response1">Réponse</label>
    </div>

    <div class="form-group">
      <select
        :class="`form-control${question2 === 0 ? ' form-control-empty' : ''}`"
        data-ob1-component="FormControlEmpty"
        id="question2"
        :value="question2"
        @change="$emit('update:question2', parseInt($event.target.value))"
        aria-labelledby="label-q2"
        required
        :disabled="question1 === 0 || response1.length === 0"
      >
        <option :value="0"></option>
        <option v-for="q in questions2" :key="q.id" :value="q.id">{{ q.label }}</option>
      </select>
      <label id="label-q2" class="form-control-placeholder" for="question2">Question 2</label>
    </div>
    <div class="form-group">
      <input type="text" id="response2" data-ob1-component="FormControlEmpty"
        :class="`form-control${response2.length === 0 ? ' form-control-empty' : ''}`"
        :value="response2" @input="$emit('update:response2', $event.target.value)"
        aria-labelledby="label-r2" required :disabled="question1 === 0 || response1.length === 0 || question2 === 0" />
      <label id="label-r2" class="form-control-placeholder" for="response2">Réponse</label>
    </div>

    <div class="form-group">
      <select
        :class="`form-control${question3 === 0 ? ' form-control-empty' : ''}`"
        data-ob1-component="FormControlEmpty"
        id="question3"
        :value="question3"
        @change="$emit('update:question3', parseInt($event.target.value))"
        aria-labelledby="label-q3"
        required
        :disabled="question1 === 0 || response1.length === 0 || question2 === 0 || response2.length === 0"
      >
        <option :value="0"></option>
        <option v-for="q in questions3" :key="q.id" :value="q.id">{{ q.label }}</option>
      </select>
      <label id="label-q3" class="form-control-placeholder" for="question3">Question 3</label>
    </div>
    <div class="form-group">
      <input type="text" id="response3" data-ob1-component="FormControlEmpty"
        :class="`form-control${response3.length === 0 ? ' form-control-empty' : ''}`"
        :value="response3" @input="$emit('update:response3', $event.target.value)"
        aria-labelledby="label-r3" required :disabled="question1 === 0 || response1.length === 0 || question2 === 0 || response2.length === 0 || question3 === 0" />
      <label id="label-r3" class="form-control-placeholder" for="response3">Réponse</label>
    </div>

    <button
      @click="$emit('submit')"
      :disabled="isLoading || isBlocked || question1 === 0 || response1.length === 0 || question2 === 0 || response2.length === 0 || question3 === 0 || response3.length === 0"
      class="btn btn-info mr-1 mb-1 mb-md-0"
      type="button"
    >
      Valider
    </button>
  </div>
</template>

<script>
export default {
  name: 'StepSetupQuestions',
  props: {
    question1: { type: Number, required: true },
    response1: { type: String, required: true },
    question2: { type: Number, required: true },
    response2: { type: String, required: true },
    question3: { type: Number, required: true },
    response3: { type: String, required: true },
    questions1: { type: Array, required: true },
    questions2: { type: Array, default: () => [] },
    questions3: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false },
    isBlocked: { type: Boolean, default: false },
  },
  emits: ['update:question1', 'update:response1', 'update:question2', 'update:response2', 'update:question3', 'update:response3', 'submit'],
}
</script>
